import type { AxiosInstance } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type {
	OsobyKomunikacniUdajeRosSeznamDto,
	OsobyPodnikatelRozsireneSeznamDto,
	OsobyPodnikatelSeznamDto,
	OsobyPodnikatelSouhlasDto,
} from '../generated';

export const rosCommunicationQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyKomunikacniUdajeRosSeznamDto> => {
	govApiLog('/api/v1/podnikatele/komunikace');
	const { data } = await axiosInstance.get('/api/v1/podnikatele/komunikace');
	return data;
};

export const rosBusinessPersonQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyPodnikatelSeznamDto> => {
	govApiLog('/api/v1/podnikatele');
	const { data } = await axiosInstance.get<OsobyPodnikatelSeznamDto>(
		'/api/v1/podnikatele'
	);
	return data;
};

export const rosBusinessPersonExtendedQuery = async (
	axiosInstance: AxiosInstance
): Promise<OsobyPodnikatelRozsireneSeznamDto> => {
	const { data } = await axiosInstance.get<OsobyPodnikatelRozsireneSeznamDto>(
		'/api/v1/podnikatele/rozsirene'
	);

	return data;
};

export const rosBusinessPersonAgreementQuery = async <Params>(
	axiosInstance: AxiosInstance,
	params: Params
): Promise<OsobyPodnikatelSouhlasDto> => {
	govApiLog('/api/v1/podnikatele/souhlas');
	const { data } = await axiosInstance.get('/api/v1/podnikatele/souhlas', {
		params,
	});
	return data;
};
